import { MICROSEC_MICRO_IDS } from '@microsec/constants';

export const environment = {
  module: MICROSEC_MICRO_IDS,
  production: false,
  useMockData: false,
  keycloak: {
    isTest: false,
    realm: 'microsec',
    clientId: 'kciam-console',
  },
};
